import {HTTP} from '../../../../services/api-service.js';
import commonObj from '../../../../services/common.js';
var common = new commonObj();
var baseUrl = common.baseURL;

const GREnquiryStore = {
    namespaced: true,
    actions:{
        getStockBalance({commit,state},param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/Stock/StockBalance', param).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        },
        exportFile({commit,state},param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/mm/export', state.q, {responseType : 'blob'}).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        }
    }
};
export default GREnquiryStore;